import React from 'react';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import { func, object } from 'prop-types';
import { compose, lifecycle, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import Button from '../../../common/buttons/DeprecatedButton/DeprecatedButton';
import updateListener from '../../../common/helpers/utils/EventListenerUtils';
import { hideDeleteErrorModal } from '@mm/state/actions/viewActions';
import { ENTER_KEY_NAME, ESCAPE_KEY_NAME } from '@mm/constants/keys-codes';
import '../../features/build/components/modals/Modal.scss';
import './DeleteErrorModal.scss';

const DeleteErrorModalBase = ({ hide, config: { show, message } }) => (
  <Modal isOpen={show} toggle={hide} className="modal-component">
    <ModalBody>
      <h3 className="delete-error-modal__container">{`${message}`}</h3>
    </ModalBody>
    <ModalFooter>
      <Button onClick={hide} invert small>
        OK
      </Button>
    </ModalFooter>
  </Modal>
);

DeleteErrorModalBase.propTypes = {
  hide: func.isRequired,
  config: object.isRequired,
};

const mapStateToProps = state => ({ config: state.view.deleteErrorModal });

const mapDispatchToProps = dispatch => ({
  hide: () => dispatch(hideDeleteErrorModal()),
});

function componentWillReceiveProps(nextProps) {
  const {
    config: { show },
    onHideKeyDown,
  } = this.props;
  updateListener(nextProps.config.show, show, 'keydown', onHideKeyDown);
}

const onHideKeyDown =
  ({ hide }) =>
  e => {
    if (e.key === ENTER_KEY_NAME || e.key === ESCAPE_KEY_NAME) {
      hide();
      e.preventDefault();
    }
  };

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({ onHideKeyDown }),
  lifecycle({ componentWillReceiveProps }),
)

export default enhance(DeleteErrorModalBase);
